"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const IntelligenceBase_1 = __importDefault(require("./IntelligenceBase"));
class Intelligence extends IntelligenceBase_1.default {
}
module.exports = Intelligence;
